import {GET} from './fetch.ts';
import {parseDom} from '../utils.ts';

export async function loadLegacyDiff(host: HTMLElement): Promise<void> {
  const url = new URL(window.location.href);
  url.searchParams.set('renderer', 'legacy');
  url.searchParams.set('file-only', 'true');
  url.searchParams.delete('files');
  url.searchParams.append('files', host.getAttribute('data-path')!);
  const oldName = host.closest('.diff-file-box')!.getAttribute('data-old-filename');
  if (oldName) url.searchParams.append('files', oldName);
  const response = await GET(url.href);
  if (!response.ok) throw new Error(`Unable to load fallback diff: ${response.status}`);
  const body = parseDom(await response.text(), 'text/html').querySelector('#diff-file-boxes .file-body')!;
  host.replaceWith(...body.children);
}
